import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FlexSection, FlexContainer, FlexDiv } from "@/components/Atoms/Box";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";
import theme from "@/foundation/Theme";
import { Typography } from "@/foundation/Typography/V2";
import Filters from "./Filters";

function JobOpenings(props) {
  const { data = {}, landingData = {}, jobRef, width } = props || {};
  const tableHeader = {
    title: "Team",
    rhsData: [
      { title: "Role", className: "role" },
      { title: "Location", className: "location" },
      { title: "Type", className: "type" },
      { title: "", className: "action" },
    ],
  };
  const [filter, setFilter] = useState("ALL");
  const [currentListing, setCurrentListing] = useState([]);
  const [groupedJobs, setGroupedJobs] = useState({});

  const groupData = (jobs) => {
    let groupedData = {};

    jobs.forEach((job) => {
      if (job?.jobs?.length) groupedData[job?.dept_name] = job;
    });

    return groupedData;
  };

  useEffect(() => {
    const groupedData = groupData(data?.jobs);
    setGroupedJobs(groupedData);
    setCurrentListing(Object.values(groupedData));
  }, [data]);

  const onFilterChange = (_filter) => {
    const filteredList =
      _filter !== "ALL" ? [groupedJobs[_filter]] : Object.values(groupedJobs);
    setFilter(_filter);
    setCurrentListing(filteredList);
  };

  return (
    <>
      <SectionWrap ref={jobRef}>
        <Container>
          <TextBox alignItems={"center"} flexDirection={"column"}>
            <Badge
              variant="label2"
              color={theme.colorsV2.primary.shade_900}
              textAlign={"center"}
            >
              {landingData?.career?.badge}
            </Badge>
            <HeadingTypo
              variant="display4"
              textAlign={"center"}
              color={theme.colorsV2.gray.shade_900}
            >
              {landingData?.career?.title}
            </HeadingTypo>
            <Typography
              variant={"paragraph1"}
              color={theme.colorsV2.gray.shade_600}
              textAlign={"center"}
            >
              {landingData?.career?.subtitle}
            </Typography>
          </TextBox>
          {Object.keys(groupedJobs)?.length > 0 && (
            <FilterWrapper flexDirection={"column"}>
              <Filters
                data={groupedJobs}
                filter={filter}
                setFilter={onFilterChange}
              />
            </FilterWrapper>
          )}
          {Object.keys(groupedJobs)?.length > 0 && (
            <TableWrap>
              {width > 992 && (
                <TableHeaderWrap>
                  <Column>
                    <Typography
                      variant={"paragraph3"}
                      color={theme.colorsV2.gray.shade_700}
                    >
                      {tableHeader?.title}
                    </Typography>
                  </Column>
                  <OuterColumn>
                    {tableHeader?.rhsData?.map((item, index) => {
                      return (
                        <InnerColumn key={index} className={item.className}>
                          <Typography
                            variant={"paragraph3"}
                            color={theme.colorsV2.gray.shade_700}
                          >
                            {item?.title}
                          </Typography>
                        </InnerColumn>
                      );
                    })}
                  </OuterColumn>
                </TableHeaderWrap>
              )}
              {currentListing?.length > 0 && (
                <>
                  {currentListing?.map((job, k) => {
                    return (
                      <TableRow key={k}>
                        <Column>
                          <Heading
                            variant={"heading4"}
                            color={theme.colorsV2.primary.shade_900}
                          >
                            {job.dept_name_display}
                          </Heading>
                        </Column>
                        <RhsData flex={"1"} flexDirection={"column"}>
                          {job.jobs?.map((item, index) => {
                            return (
                              <OuterColumn
                                key={index}
                                isData
                                onClick={() => {
                                  width <= 992 &&
                                    window.open(`/careers/${item.id}`);
                                }}
                              >
                                {width <= 992 && (
                                  <ArrowUpRight>
                                    <StyledSvgSprite
                                      icon={"icon-ArrowUpRight"}
                                      height={"16px"}
                                      width={"16px"}
                                      fill={theme.colorsV2.primary.shade_700}
                                    />
                                  </ArrowUpRight>
                                )}
                                <InnerColumn className={"role"}>
                                  <Role
                                    variant={"label1"}
                                    color={theme.colors.black}
                                    onClick={() => {
                                      width >= 993 &&
                                        window.open(`/careers/${item.id}`);
                                    }}
                                  >
                                    {item?.role}
                                  </Role>
                                </InnerColumn>
                                <InnerColumn className={"location"}>
                                  <IconTypo
                                    variant={"label3"}
                                    color={theme.colorsV2.gray.shade_700}
                                  >
                                    <StyledSvgSprite
                                      icon={"icon-MapPin"}
                                      height={"16px"}
                                      width={"16px"}
                                      fill={theme.colorsV2.gray.shade_700}
                                    />
                                    {item?.location}
                                  </IconTypo>
                                </InnerColumn>
                                <InnerColumn className={"type"}>
                                  <IconTypo
                                    variant={"paragraph3"}
                                    color={theme.colorsV2.gray.shade_700}
                                  >
                                    <StyledSvgSprite
                                      icon={"icon-clock"}
                                      height={"16px"}
                                      width={"16px"}
                                      fill={theme.colorsV2.gray.shade_700}
                                    />
                                    {item?.type}
                                  </IconTypo>
                                </InnerColumn>
                                <InnerColumn
                                  className={"action"}
                                  justifyContent={"flex-end"}
                                >
                                  <Typography
                                    variant="link1"
                                    href={`/careers/${item.id}/`}
                                    target="_blank"
                                  >
                                    <ViewDetailCTA
                                      variant={"label3"}
                                      color={theme.colorsV2.primary.shade_700}
                                    >
                                      View Job
                                      <StyledSvgSprite
                                        icon={"icon-ArrowUpRight"}
                                        height={"16px"}
                                        width={"16px"}
                                        fill={theme.colorsV2.primary.shade_700}
                                      />
                                    </ViewDetailCTA>
                                  </Typography>
                                </InnerColumn>
                              </OuterColumn>
                            );
                          })}
                        </RhsData>
                      </TableRow>
                    );
                  })}
                </>
              )}
            </TableWrap>
          )}
        </Container>
      </SectionWrap>
    </>
  );
}

export default JobOpenings;

const SectionWrap = styled(FlexSection)`
  background-color: ${theme.colors.white};
  background-image: linear-gradient(
    180deg,
    ${theme.colorsV2.primary.shade_25} 0%,
    ${theme.colors.white} 21.88%
  );
  padding: 32px 0 60px;
  @media only screen and (max-width: 1279px) {
    padding: 40px 0;
  }
`;
const Container = styled(FlexContainer)`
  flex-direction: column;
`;
const Badge = styled(Typography)`
  padding: 8px 16px;
  background-color: ${theme.colors.white};
  border-radius: 24px;
  margin-bottom: 24px;
  @media only screen and (max-width: 1279px) {
    margin-bottom: 8px;
  }
`;
const FilterWrapper = styled(FlexDiv)`
  padding: 72px 0 48px;
  @media only screen and (max-width: 1279px) {
    padding: 40px 0;
  }
`;
const TableWrap = styled(FlexDiv)`
  flex-direction: column;
`;
const TableHeaderWrap = styled(FlexDiv)`
  width: 100%;
  padding: 24px 0;
  border-bottom: 1px solid ${theme.colors.black};
  background-color: ${theme.colors.white};
`;
const Column = styled(FlexDiv)`
  width: 100%;
  max-width: 25%;
  padding-right: 8px;
  @media only screen and (max-width: 992px) {
    max-width: 100%;
  }
`;
const TableRow = styled(FlexDiv)`
  padding: 24px 0;
  border-bottom: 1px solid ${theme.colors.black};
  @media only screen and (max-width: 992px) {
    flex-direction: column;
  }
`;
const OuterColumn = styled(FlexDiv)`
  flex: 1;
  align-items: center;
  ${({ isData }) =>
    isData &&
    `
  position: relative;
  padding: 20px 0;
  border-bottom: 1px solid ${theme.colorsV2.gray.shade_100};
  &:last-child{
      border-bottom: 0;
  }
  @media only screen and (max-width: 992px) {
    padding:16px;
    background-color: ${theme.colorsV2.gray.shade_50};
    border-bottom: 0;
    flex-wrap: wrap;
    margin-bottom: 8px;
    border-radius:16px;
    &:last-child{
      margin-bottom: 0;
    }
  }
  `}
`;
const InnerColumn = styled(FlexDiv)`
  max-width: 33.33%;
  width: 100%;
  padding-right: 8px;
  &.action,
  &.type {
    max-width: 16.55%;
    @media only screen and (max-width: 1169px) {
      max-width: 20%;
    }
  }
  @media only screen and (max-width: 1169px) {
    max-width: 30%;
  }
  @media only screen and (max-width: 992px) {
    &.role {
      max-width: 100%;
      padding-right: 40px;
      margin-bottom: 8px;
    }
    &.location {
      max-width: 70%;
    }
    &.type {
      max-width: 30%;
    }
    &.action {
      display: none;
    }
  }
  @media only screen and (max-width: 385px) {
    &.location,
    &.type {
      max-width: 100%;
    }
    &.location {
      margin-bottom: 8px;
    }
  }
`;
const IconTypo = styled(Typography)`
  padding-left: 24px;
  position: relative;
  .icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
  }
`;
const ViewDetailCTA = styled(Typography)`
  cursor: pointer;
  background-color: ${theme.colorsV2.blueGray.shade_50};
  padding: 8px 24px;
  display: flex;
  align-items: center;
  border-radius: 16px;
  .icon {
    margin-left: 10px;
  }
`;
const RhsData = styled(FlexDiv)``;
const Heading = styled(Typography)`
  padding: 8px;
  @media only screen and (max-width: 992px) {
    padding: 0 16px 16px;
  }
`;
const HeadingTypo = styled(Typography)`
  margin-bottom: 24px;
  @media only screen and (max-width: 1279px) {
    margin-bottom: 8px;
  }
  @media only screen and (max-width: 767px) {
    max-width: 340px;
    margin: 0 auto 8px;
  }
`;
const TextBox = styled(FlexDiv)`
  @media only screen and (max-width: 1279px) {
    padding: 0 24px;
  }
`;
const ArrowUpRight = styled(FlexDiv)`
  position: absolute;
  right: 16px;
  top: 16px;
  padding: 4px;
  border-radius: 8px;
  background-color: ${theme.colors.white};
`;
const Role = styled(Typography)`
  cursor: pointer;
`;
